
import Dashboard from "./Dashboard";
import ContactDetails from "./Pages/ContactDetails/ContactDetails";
import Version from "./Pages/Controls/Version";
import Cms from "./Pages/Controls/Cms";
import GameSetting from "./Pages/GameSetting/GameSetting";
import AddCash from "./Pages/Payment/AddCash";
import Bet from "./Pages/Payment/Bet";
import History from "./Pages/Payment/History";
import Payout from "./Pages/Payment/Payout";
import Reward from "./Pages/Payment/Reward";
import Win from "./Pages/Payment/Win";
import LivePlayerApp from "./Pages/Player/LivePlayerApp";
import LivePlayerGame from "./Pages/Player/LivePlayerGame";
import PlayerBanned from "./Pages/Player/PlayerBanned";
import AndroidPlayer from "./Pages/Player/AndroidPlayer";
import IosPlayer from "./Pages/Player/IosPlayer";
import PendingKycPlayer from "./Pages/Player/PendingKycPlayer";
import PlayerList from "./Pages/Player/PlayerList";
import HistoryReports from "./Pages/Reports/HistoryReports";
import PlayerReports from "./Pages/Reports/PlayerReports";
import Admin from "./Pages/Staff.js/Admin";
import Player from "./Pages/Staff.js/Player";
import SendNotification from "./Pages/Controls/SendNotification";
import AdminList from "./Pages/Admin/AdminList";
import AccessUser from "./Pages/Admin/AccessUser";
import Banner from "./Pages/Controls/Banner";
import CoinPackage from "./Pages/Controls/CoinPackage";
import Social from "./Pages/Controls/Social";
import Notification from "./Pages/Controls/Notification";
import BotForm from "./Pages/Controls/BotForm";
import RoomTier from "./Pages/Controls/RoomTier";
import Notice from "./Pages/Controls/Notice";
import Poll from "./Pages/Controls/Poll";
import Games from "./Pages/Controls/Games";
import Faq from "./Pages/Controls/Faq";
import SpinWheel from "./Pages/Controls/SpinWheel";
import RestrictedArea from "./Pages/Controls/RestrictedArea";
import Bonus from "./Pages/GameSetting/Bonus";
import GameHandle from "./Pages/GameSetting/GameHandle";
import GameVersion from "./Pages/GameSetting/GameVersion";
import Ludo from "./Pages/Tournament/Ludo";
import Tournament from "./Pages/Tournament/Tournamentt";
import Withdraw from "./Pages/GameSetting/Withdraw";
import AddMoney from "./Pages/GameSetting/AddMoney";
import StripePayment from "./Pages/Stripe/Stripe-Payment";
import Sucess from "./Pages/Stripe/Sucess";
import Cancel from "./Pages/Stripe/Cancel";

// income route
import IncomeDetails from "./Pages/Income/IncomeDetails";
import SeparateNotification from "./Pages/Controls/SeparateNotification";
import LudoIncome from "./Pages/Income/LudoIncome";
import Ticket from "./Pages/Controls/Ticket";
import BlockBlastContest from "./Pages/Contest/BlockBlastContest";
import CandyCreamContest from "./Pages/Contest/CandyCreamContest";
import ChessGameBitContest from "./Pages/Contest/ChessGameBitContest";
import ClassyCarromContest from "./Pages/Contest/ClassyCarromContest";
import EightBallPoolLiteContest from "./Pages/Contest/EightBallPoolLiteContest";
import LogicLineContest from "./Pages/Contest/LogicLineContest";
import LudoContest from "./Pages/Contest/LudoContest";
import NumberPuzzle2248Contest from "./Pages/Contest/NumberPuzzle2248Contest";
import PokerContest from "./Pages/Contest/PokerContest";
import SmashBlockContest from "./Pages/Contest/SmashBlockContest";
import TicTacToeContest from "./Pages/Contest/TicTacToeContest";
import WordBookContest from "./Pages/Contest/WordBookContest";
import Advertisement from "./Pages/advertisement/Advertisement";
import Task from "./Pages/Controls/Task";
import Chess from "./Pages/Tournament/Chess";
import BlockBlast from "./Pages/Tournament/BlockBlast";
import Candy from "./Pages/Tournament/Candy";

export const routesConfig = [
  { path: "/dashboard", element: Dashboard, permission: "dashboardCount" },
  { path: "/playerlist", element: PlayerList, permission: "getPlayerList" },
  { path: "/playerbanned", element: PlayerBanned, permission: "getPlayerBannedList" },
  { path: "/android-player", element: AndroidPlayer, permission: "getPlayerList" },
  { path: "/ios-player", element: IosPlayer, permission: "getPlayerList" },
  { path: "/pending-kyc-player", element: PendingKycPlayer, permission: "getPlayerList" },
  { path: "/history", element: History, permission: "getHistoryList" },
  { path: "/addcash", element: AddCash, permission: "getAddCashList" },
  { path: "/payout", element: Payout, permission: "getPayoutList" },
  { path: "/reward", element: Reward, permission: "getAddCashList" },
  { path: "/admin", element: Admin, permission: "getStaffAdminList" },
  { path: "/player", element: Player, permission: "getStaffPlayerList" },
  { path: "/banner", element: Banner, permission: "getBannerList" },
  { path: "/live-player-app", element: LivePlayerApp, permission: "getLivePlayerAppList" },
  { path: "/live-player-game", element: LivePlayerGame, permission: "getLivePlayerGameList" },
  { path: "/bet", element: Bet, permission: "getBetList" },
  { path: "/win", element: Win, permission: "getWinList" },
  { path: "/bot-form", element: BotForm, permission: "getBotForm" },
  { path: "/room-tier", element: RoomTier, permission: "getRoomTier" },
  { path: "/notice", element: Notice, permission: "getNoticeList" },
  { path: "/poll", element: Poll, permission: "getBannerList" },
  { path: "/games", element: Games, permission: "contactDetailsList" },
  { path: "/task", element: Task, permission: "contactDetailsList" },
  { path: "/faq", element: Faq, permission: "getRoomTier" },
  { path: "/spin-wheel", element: SpinWheel, permission: "getSpinWheelList" },
  { path: "/restrictedarea", element: RestrictedArea, permission: "getRestrictedArea" },
  { path: "/coin-package", element: CoinPackage, permission: "getCoinPackageList" },
  { path: "/social", element: Social, permission: "getSocialList" },
  { path: "/ludo-tournament-list", element: Ludo, permission: "getEightBallPoolLiteTour" },
  { path: "/chess-tournament-list", element: Chess, permission: "getEightBallPoolLiteTour" },
  { path: "/block-blast-tournament-list", element: BlockBlast, permission: "getEightBallPoolLiteTour" },
  { path: "/candy-blast-tournament-list", element: Candy, permission: "getEightBallPoolLiteTour" },
  { path: "/tournament-list", element: Tournament, permission: "getEightBallPoolLiteTour" },
  { path: "/blockblast-contest-list", element: BlockBlastContest, permission: "getEightBallPoolLiteTour" },
  { path: "/candycream-contest-list", element: CandyCreamContest, permission: "getEightBallPoolLiteTour" },
  { path: "/chessgamebit-contest-list", element: ChessGameBitContest, permission: "getEightBallPoolLiteTour" },
  { path: "/classycarrom-contest-list", element: ClassyCarromContest, permission: "getEightBallPoolLiteTour" },
  { path: "/eightballpoollite-contest-list", element: EightBallPoolLiteContest, permission: "getEightBallPoolLiteTour" },
  { path: "/logicline-contest-list", element: LogicLineContest, permission: "getEightBallPoolLiteTour" },
  { path: "/ludo-contest-list", element: LudoContest, permission: "getEightBallPoolLiteTour" },
  { path: "/numberpuzzle2248-contest-list", element: NumberPuzzle2248Contest, permission: "getEightBallPoolLiteTour" },
  { path: "/poker-contest-list", element: PokerContest, permission: "getEightBallPoolLiteTour" },
  { path: "/smashblock-contest-list", element: SmashBlockContest, permission: "getEightBallPoolLiteTour" },
  { path: "/tictactoe-contest-list", element: TicTacToeContest, permission: "getEightBallPoolLiteTour" },
  { path: "/wordbook-contest-list", element: WordBookContest, permission: "getEightBallPoolLiteTour" },
  { path: "/admin-list", element: AdminList, permission: "getAdminList" },
  { path: "/access-user", element: AccessUser, permission: "adminAccessUser" },
  { path: "/notification", element: Notification, permission: "getNotificationList" },
  { path: "/separate-notification", element: SeparateNotification, permission: "getNotificationListSeparate" },
  { path: "/bonus", element: Bonus, permission: "getBonusList" },
  { path: "/game-handle", element: GameHandle, permission: "getBonusList" },
  { path: "/game-version", element: GameVersion, permission: "getBonusList" },
  { path: "/income-details", element: IncomeDetails, permission: "getIncomeList" },
  { path: "/ludo-income", element: LudoIncome, permission: "getIncomeList" },
  { path: "/send-notification", element: SendNotification, permission: "getNotificationList" },
  { path: "/version", element: Version, permission: "getVersionList" },
  { path: "/cms", element: Cms, permission: "getVersionList" },
  { path: "/ticket", element: Ticket, permission: "contactDetailsList" },
  { path: "/reports-player", element: PlayerReports, permission: "getReportPlayerList" },
  { path: "/game-setting", element: GameSetting, permission: "getBonusList" },
  { path: "/history-reports", element: HistoryReports, permission: "getReportHistoryList" },
  { path: "/contact-details", element: ContactDetails, permission: "contactDetailsList" },
  { path: "/withdraw", element: Withdraw, permission: "getWithdrawList" },
  { path: "/addmoney", element: AddMoney, permission: "getWithdrawList" },
  { path: "/payment", element: StripePayment },
  { path: "/sucess", element: Sucess },
  { path: "/cancel", element: Cancel },
  { path: "/advertisement", element: Advertisement, permission: "getNoticeList" },
];
